import React from "react";
import PropTypes from "prop-types";
import "./styles/main.scss";

const number_to_human_size = (size) => {
  if (size < 1024) { return `${size} bytes`; }
  if (size < 1024.0 * 1024.0) { return `${(size / 1024.0).toFixed(1)} KB`; }
  if (size < 1024.0 * 1024.0 * 1024.0) { return `${(size / 1024.0 / 1024.0).toFixed(1)} MB`; }
  return `${(size / 1024.0 / 1024.0 / 1024.0).toFixed(1)} GB`;
};

const VisibleAttachment = ({ extension, filename, height, size, thumbnail, width }) => (
  <div className="visible-attachment">
    <div className="half-container">
      <div className="attachment-thumbnail">
        <img src={thumbnail} />
      </div>
      <div className="attachment-name">
        <label className="modal-label">
          {' '}
          {t('Name')}
          {' '}
        </label>
        <p>{filename || "NA"}</p>
      </div>
    </div>
    <div className="half-container">
      <div className="attachment-filetype">
        <label className="modal-label">
          {' '}
          {t('File Type')}
          {' '}
        </label>
        <p>{extension || "NA"}</p>
      </div>
      <div className="attachment-size">
        <label className="modal-label">
          {' '}
          {t('Size')}
          {' '}
        </label>
        <p>
          {size ? (
            <span>
              {' '}
              {number_to_human_size(size)}
              {' '}
            </span>
          ) : "NA"}

        </p>
      </div>
      <div className="attachment-dimensions">
        <label className="modal-label">
          {' '}
          {t('Dimensions')}
          {' '}
        </label>
        <p>
          {width && height ? (
            <span>
              {width}
              {' '}
              x
              {' '}
              {height}
            </span>
          ) : "NA"}

        </p>
      </div>
    </div>
  </div>
);

VisibleAttachment.propTypes = {
  extension: PropTypes.string,
  filename: PropTypes.string,
  height: PropTypes.number,
  size: PropTypes.number,
  thumbnail: PropTypes.string,
  width: PropTypes.number
};

VisibleAttachment.defaultProps = {
  extension: '',
  filename: '',
  height: null,
  size: null,
  thumbnail: null,
  width: null,
};

export default VisibleAttachment;
